import types from 'helpers/constants';

const initialState = {};

// eslint-disable-next-line default-param-last -- FIXME
const Company = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_COMPANY:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default Company;
